<!--各农机企业鉴定数量-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data='identifyNumber'
      :class-option="classOption"
    >
      <div
        class="item-class"
        v-for="(item,index) in identifyNumber"
        :key="index"
      >
        <div class="item-top">{{item.enterpriseName}}</div>
        <div class="item-bottom">
          <div class="item-tottom-left">
            <div class="num" :data-content="numberSeparatorCompute(item.yearCount)">{{item.yearCount || 0 | toThousandFilter}}</div>
            <div class="title">当年鉴定数量</div>
          </div>
          <div class="item-tottom-middle"></div>
          <div class="item-tottom-right">
            <div class="num" :data-content="numberSeparatorCompute(item.totalCount)">{{item.totalCount || 0 | toThousandFilter}}</div>
            <div class="title">累计鉴定数量</div>
          </div>
        </div>
      </div>
    </seamless-scroll>
  </div>
</template>

<script>
export default {
  props: {
    identifyNumber: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 3
      },
 
    }
  },
  methods: {
 
  },
  computed: {
    numberSeparatorCompute() {
      return function(number){
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        }else {
          return number.toFixed().replace(regex, ',');
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}


.location-number {
  height: 100%;
  font-family: Microsoft YaHei;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .item-class {
    position: relative;
    width: vw(314);
    height: vh(83);
    padding: vh(6) vw(15);
    margin-top: vh(12);
    background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_list_jdsl.png");
    background-size: 100%;
    background-repeat: no-repeat;
    font-size: fontSize(14);
    color: #DEFFE9;
    .item-top {
      max-width: vw(283);
      padding-bottom: vh(5);
      font-weight: bold;
      font-size: fontSize(14);
      font-style: italic;
      color: #DDFDFF;
      background: linear-gradient(180deg, #FFFFFF 35.009765625%, #BDFFCC 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      border-bottom: 1px dashed #0d7330;
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 显示省略号 */
    }
    .item-bottom {
      display: flex;
      align-items: center;
      .item-tottom-left {
        flex: 1;
        .num {
          position: relative;
          font-family: Rajdhani-Bold;
          font-weight: 600;
          font-size: fontSize(26);
          font-style: italic;
          text-align: center;
          background: linear-gradient(0deg, #F7D58F 0%, rgba(255,255,255,1) 50%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .num::before {
          content: attr(data-content);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: transparent;
          text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
        }
        .title {
          text-align: center;
          color: #FFF4DE;
          margin-top: vh(-4);
        }
      }
      .item-tottom-middle {
        width: vw(1);
        height: vh(41);
        background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl_line.png");
        background-size: 100%;
        background-repeat: no-repeat;
      }
      .item-tottom-right {
        flex: 1;
        text-align: center;
        .num {
          font-family: Rajdhani-Bold;
          font-weight: 600;
          font-size: fontSize(26);
          font-style: italic;
          background: linear-gradient(0deg, #8FF7B4 0%, rgba(255,255,255,1) 60%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .num::before {
          content: attr(data-content);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: transparent;
          text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
        }
        .title {
          margin-top: vh(-4);
          text-align: center;
          color: #DEFFE9;
        }
      }
    }
  }
 
 
}
</style>
